<template>
  <div class="block__footer"><hr>
    <span class="item-count">Total: {{itemsCount}} items</span>
    <span>Items per page:</span>
    <select class="select block__footer__select" v-model="itemsPerPage" @change="perPageChange">
      <option :value="value" v-for="value in perPage">{{value}}</option>
    </select>

    <div class="pagination">
      <button class="icon-button prev-green" @click="prev"></button>
      <span>{{pageNumber + 1}} / {{pageCount}}</span>
      <button class="icon-button next-green" @click="next"></button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["perPage", "itemsCount"],
  data: function () {
    return {
      itemsPerPage: 8,
      pageNumber: 0
    };
  },
  ready: function () {
    this.itemsPerPage = this.perPage ? this.perPage[0] : 8;
    this.$dispatch("pagechange", this.pageNumber, this.itemsPerPage);
  },
  computed: {
    pageCount () {
      return Math.ceil(this.itemsCount / this.itemsPerPage);
    }
  },
  methods: {
    perPageChange () {
      this.pageNumber = 0;
      this.dispatch();
    },
    next () {
      this.pageNumber = Math.min(this.pageCount - 1, this.pageNumber + 1);
      this.dispatch();
    },
    prev () {
      this.pageNumber = Math.max(0, this.pageNumber - 1);
      this.dispatch();
    },
    dispatch () {
      this.$dispatch("pagechange", this.pageNumber, this.itemsPerPage);
    }
  },
  events: {
    "paginator-update": function (item) {
      this.pageNumber = 0;
      this.dispatch();
    }
  }
};
</script>

<style lang="scss">
  @import '../assets/scss/variables.scss';
  @import '../assets/scss/mixins.scss';

  .block__footer hr{
    border: none;
    border-top: 1px solid $green_dark;
    margin-bottom: 15px;
  }
  
  .block__footer span{
    display: inline-block;
    margin-right: 5px;

    &.item-count{
      margin-right: 30px;
    }
  }

  .block__footer__select{
    vertical-align: middle;
    padding-right: 20px;
  }

  .pagination{
    float: right;

    .prev-green{
      margin-right: 10px;
    }

    .next-green{
      margin-left: 10px;
    }

    .icon-button{
      &:after{
        width: 12px;
        height: 12px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// Paginator.vue?12085268